module.exports = __webpack_public_path__ + "assets/4491dd5deb3f2b13148c8ab995d446ed.svg";